<template src="./Comprar.html"></template>
<style lang="scss" scoped src="./Comprar.scss"></style>

<script>
import { translate } from '../../../services/translate.service';

import service from '../../../services/qrcode.service';
import tremService from '../../../services/ondeEstaTrem.service';
import { types } from '../../../store';
import * as helper from '../helper';
const QUANTIDADE_MAXIMA = 10;
export default {
  name: 'bilhete-especial-comprar',
  props:{
    data:{
      type: Object
    },
  },
  components: {
  },
  data() {
    return {
      loaded: false,
      service,
      helper,
    }
  },
  computed: {
    current() {
      return this.$store.state.qrcode_current || null;
    },
    groups() {
      return this.$store.state.qrcode_groups || [];
    },
    selected() {
      return this.$store.state.qrcode_selected || []
    },
    limite() {
      return this.selected.length >= QUANTIDADE_MAXIMA;
    },
  },
  methods: {
    t:translate,
    diminuir(bilhete) {
      let selected = this.selected || [];
      if(selected.length >= 1){
          let index = selected.findIndex(b => b.idProduto == bilhete.idProduto);
          if(index != -1) {
            selected.splice(index, 1);
          }
      }
      this.$store.dispatch(types.SET_QRCODE_SELECTED, selected);
    },
    aumentar(bilhete) {
      let selected = this.selected || [];
      if(selected.length < QUANTIDADE_MAXIMA){
        selected.push(bilhete);
      }
      this.$store.dispatch(types.SET_QRCODE_SELECTED, selected);
    },
    count(bilhete) {
      return this.selected.filter(x => x.idProduto == bilhete.idProduto).length;
    },
    avancar() {
      if(this.selected.length) {
        this.$router.push({ name: 'bilhete-especial-pagamento'});
      }
    },
  },
  mounted(){
    if(!this.current) {
      this.$router.push({ name: 'home' });
      return;
    }
    if(!this.ativos) {
      tremService.getEstacoesDisponiveis().then(estacoes => {
        this.$store.dispatch(types.SET_ESTACOES, estacoes.data);
        service.getQRCodesAtivos().then(res => {
          let groups = service.groupTickets(res.data);
          console.log('groups', groups);
          this.loaded = true;
          this.$store.dispatch(types.SET_QRCODE_GROUPS, groups);
        }).catch(() => {
          this.$router.push({ name: 'home' });
        });
      }).catch(() => {
        this.$router.push({ name: 'home' });
      });
    }
  }
}
</script>
